import { isBillingPlanType } from "./entitlements";
export const LEGACY_MULTICURRENCY_ENTITLEMENT_CODE = "legacy_multicurrency";
function isRecord(value) {
    return Boolean(value && typeof value === "object" && !Array.isArray(value));
}
export function getLegacyMulticurrencyContractProjection(settings) {
    if (!isRecord(settings)) {
        return null;
    }
    const projection = settings.legacyMulticurrencyContract;
    if (!isRecord(projection) ||
        projection.version !== 1 ||
        projection.active !== true ||
        typeof projection.billingSubscriptionId !== "string" ||
        !projection.billingSubscriptionId ||
        typeof projection.billingSubscriptionItemId !== "string" ||
        !projection.billingSubscriptionItemId ||
        typeof projection.grantedAt !== "string" ||
        !projection.grantedAt ||
        typeof projection.operationId !== "string" ||
        !projection.operationId) {
        return null;
    }
    return projection;
}
export function hasLegacyMulticurrencyContractEntitlement(settings) {
    return getLegacyMulticurrencyContractProjection(settings) !== null;
}
const DISABLED_CAPABILITIES = {
    accounting: false,
    accountingPosting: false,
    customAccounting: false,
    customFields: false,
    customRoles: false,
    importDespachos: false,
    multicurrency: false,
    priceChecker: false,
    productAccountingDefaults: false,
    publicApiReferences: false,
    purchaseExtraction: false,
    receiptAccounting: false,
};
const ENABLED_CAPABILITIES = {
    accounting: true,
    accountingPosting: true,
    customAccounting: true,
    customFields: true,
    customRoles: true,
    importDespachos: true,
    multicurrency: true,
    priceChecker: true,
    productAccountingDefaults: true,
    publicApiReferences: true,
    purchaseExtraction: true,
    receiptAccounting: true,
};
export function resolvePlanCapabilities(planType) {
    if (planType === "starter" || planType === "pro") {
        return { ...DISABLED_CAPABILITIES };
    }
    return { ...ENABLED_CAPABILITIES };
}
export function planHasCapability(planType, capability, organizationSettings) {
    if (!isBillingPlanType(planType)) {
        return false;
    }
    if (capability === "multicurrency" &&
        (planType === "starter" || planType === "pro") &&
        hasLegacyMulticurrencyContractEntitlement(organizationSettings)) {
        return true;
    }
    return resolvePlanCapabilities(planType)[capability];
}
